var version = {
    "name":      "dativery",
    "buildDateCode": "20260624-183020",
    "buildDate": "Wed Jun 24 2026 18:30:20 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260624-183020",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;